<template>
<div class="home guide-page page-template-default page wp-custom-logo separate-containers nav-below-header">
  <HeadNav selectedLanguage="en" :page="pageKey" />

  <GuideBreadcrumb :items="breadcrumbItems" />

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <section class="entry-wrapper hero">
            <div class="hero-shell hero-shell--guide">
              <header class="hero-top">
                <p class="hero-kicker">{{ page.heroKicker }}</p>
                <h1>{{ page.h1 }}</h1>
              </header>
              <div class="hero-copy">
                <p v-html="page.heroIntro" />
              </div>
              <div class="hero-cta-row">
                <a
                  v-for="(action, ai) in heroActions"
                  :key="ai"
                  :href="action.href"
                  class="hero-cta-link"
                  :class="action.primary ? 'hero-cta-link--primary' : 'hero-cta-link--secondary'"
                >{{ action.label }}</a>
              </div>
            </div>
          </section>

          <div
            v-for="(section, idx) in page.sections"
            :key="idx"
            class="section-content"
            :class="section.sectionClass"
          >
            <h2 v-if="section.h2" class="h">{{ section.h2 }}</h2>
            <p v-if="section.lead" class="section-lead" v-html="section.lead" />
            <div
              v-if="section.callout"
              class="guide-callout"
              :class="'guide-callout--' + (section.callout.type || 'tip')"
            >
              <p v-html="section.callout.text" />
            </div>
            <p v-for="(p, pi) in section.paragraphs || []" :key="'p' + pi" v-html="p" />
            <div v-if="section.facts" class="hub-facts-wrap">
              <table class="hub-facts-table">
                <tbody>
                  <tr v-for="(row, ri) in section.facts" :key="ri">
                    <th scope="row">{{ row.label }}</th>
                    <td v-html="row.value" />
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="section.categoryCards" class="hub-category-grid">
              <a
                v-for="(cat, ci) in section.categoryCards"
                :key="ci"
                class="hub-category-card hub-category-card--link"
                :href="cat.href"
              >
                <div class="hub-category-card__icon" aria-hidden="true">{{ cat.icon }}</div>
                <h3 class="hub-category-card__title">{{ cat.title }}</h3>
                <ul class="hub-category-card__tasks">
                  <li v-for="(task, ti) in cat.tasks" :key="ti" v-html="task" />
                </ul>
                <span class="hub-category-card__cta">{{ cat.linkLabel || 'Open guide' }} →</span>
              </a>
            </div>
            <ul v-if="section.list" class="check-list">
              <li v-for="(item, li) in section.list" :key="li" v-html="item" />
            </ul>
            <ol v-if="section.steps" class="step-cards">
              <li v-for="(step, si) in section.steps" :key="si" v-html="step" />
            </ol>
            <div v-if="section.linkCards" class="explore-grid">
              <a
                v-for="card in section.linkCards"
                :key="card.href"
                class="explore-card"
                :href="card.href"
              >
                <span v-if="card.icon" class="explore-card__icon" aria-hidden="true">{{ card.icon }}</span>
                <strong>{{ card.label }}</strong>
                <span>{{ card.desc }}</span>
              </a>
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/gb-home-layout.scss'
import '@/css/guide-pages.scss'
import HeadNav from '@/components/HeadNav.vue'
import GuideBreadcrumb from '@/components/GuideBreadcrumb.vue'
import { CORE_PAGES } from '@/data/corePages'
import { HUB_ENHANCEMENTS } from '@/data/hubEnhancements'

export default {
  name: 'CoreHub',
  components: { HeadNav, GuideBreadcrumb },
  computed: {
    pageKey() {
      return this.$route.meta.pageKey || 'features'
    },
    page() {
      const base = CORE_PAGES[this.pageKey] || CORE_PAGES.features
      const extra = HUB_ENHANCEMENTS[this.pageKey]
      if (!extra) return base
      return {
        ...base,
        ...extra,
        sections: extra.sections || base.sections,
      }
    },
    breadcrumbItems() {
      return [
        { label: 'Home', href: '/' },
        { label: this.page.h1 },
      ]
    },
    heroActions() {
      if (this.page.heroActions && this.page.heroActions.length) {
        return this.page.heroActions
      }
      return [
        { href: '/download/', label: 'Download', primary: true },
        { href: '/safety/', label: 'Safety info', primary: false },
      ]
    },
  },
}
</script>
